import React from 'react';

export const JobModal = ({ job, onClose }) => {
  if (!job) return null;

  return (
    <div className="jmodal-overlay open" onClick={(e) => { if (e.target.classList.contains("jmodal-overlay")) onClose(); }}>
      <div className="jmodal">
        <button className="jmodal-close" onClick={onClose}>✕</button>

        <div className="jmodal-label">Role Brief</div>
        <div className="jmodal-title">{job.title}</div>
        <div className="jmodal-type">{job.type}</div>

        <div className="jmodal-meta">
          <div className="jmodal-meta-item">
            <div className="jmodal-meta-label">You keep</div>
            <div className="jmodal-meta-val red">{job.earn}</div>
          </div>
          <div className="jmodal-meta-item">
            <div className="jmodal-meta-label">Project range</div>
            <div className="jmodal-meta-val">{job.brief.range}</div>
          </div>
          <div className="jmodal-meta-item">
            <div className="jmodal-meta-label">Typical timeline</div>
            <div className="jmodal-meta-val">{job.brief.timeline}</div>
          </div>
        </div>

        <div className="jmodal-section">
          <div className="jmodal-section-label">What you'll be doing</div>
          <p className="jmodal-text">{job.brief.what}</p>
        </div>

        <div className="jmodal-section">
          <div className="jmodal-section-label">Who we're looking for</div>
          <p className="jmodal-text">{job.brief.who}</p>
        </div>

        <div className="jmodal-section">
          <div className="jmodal-section-label">How it works</div>
          <div className="jmodal-steps">
            {job.brief.how.map((step, i) => (
              <div key={i} className="jmodal-step">
                <span className="jmodal-step-num">0{i + 1}</span>
                <span className="jmodal-step-text">{step}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="jmodal-section">
          <div className="jmodal-section-label">Stack</div>
          <div className="jmodal-stack">
            {job.stack.map(t => <span key={t} className="jmodal-pill">{t}</span>)}
          </div>
        </div>

        <a href={`mailto:info@nismaystudios.in?subject=Collab%20–%20${encodeURIComponent(job.title)}&body=Hi%20Mayur%2C%0A%0AI'm%20interested%20in%20the%20${encodeURIComponent(job.title)}%20role.%0A%0AHere's%20a%20bit%20about%20what%20I've%20built%3A%0A`} className="jmodal-cta">
          Apply for this role →
        </a>
      </div>
    </div>
  );
};